import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import PictionJS from 'piction-js';
import UMOSortItem from './UMOSortItem';
import piction from '../../utils/piction';
import BoxItem from './BoxItem';
import { SearchParams } from '../../utils/searchUtils';
import { addError } from '../../actions/messageDialog';
import { addToSortLightbox } from '../../actions/umoSort';
import { addToWorkspace } from '../../actions/umo';

// serves as a wrapper for dragging and dropping
function move(array, oldIndex, newIndex) {
  if (newIndex >= array.length) {
    newIndex = array.length - 1;
  }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
}

function moveElement(array, index, offset) {
  const newIndex = index + offset;

  return move(array, index, newIndex);
}

const mapDispatchToProps = dispatch => ({
  addToSortLightbox: catID => dispatch(addToSortLightbox(catID)),
  sortUMO: (catID, umoID, orderBy) =>
    dispatch(addToWorkspace(catID, [umoID], null, { orderBy })),
  addError: err => dispatch(addError(err)),
});

// serves as a wrapper for dragging and dropping
class UMOGallerySortView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChanged: false,
    };
    this.umoItems = props.umoList.toJS();
    this.moveItem = this.moveItem.bind(this);
    this.dropItem = this.dropItem.bind(this);
  }

  componentDidMount() {
    this.props.addToSortLightbox(this.props.categoryID);
  }

  moveItem(sourceId, destinationId) {
    const sourceIndex = this.umoItems.findIndex(
      item => item.id[0] === sourceId
    );
    const destinationIndex = this.umoItems.findIndex(
      item => item.id[0] === destinationId
    );

    // If source/destination is unknown, do nothing.
    if (sourceId === -1 || destinationId === -1) {
      return;
    }

    const offset = destinationIndex - sourceIndex;

    this.umoItems = moveElement(this.umoItems, sourceIndex, offset);
    this.setState({ isChanging: true });
  }

  dropItem(umo) {
    const umoIndex = this.umoItems.findIndex(
      item => item.id[0] === umo.id
    );
    if (umoIndex !== -1) {
      this.props.sortUMO(this.props.categoryID, umo.id, umoIndex + 1);
    }
    this.setState({ isChanging: false });
  }

  render() {
    const umoList = [];
    let tempUMO;
    for (let i = 0; i < this.umoItems.length; i += 1) {
      tempUMO = new PictionJS.UMO(this.umoItems[i], { hostURL: piction.hostURL });

      umoList.push(
        <BoxItem
          key={tempUMO.id}
          id={tempUMO.id}
          onDropItem={this.dropItem}
          onMoveItem={this.moveItem}
        >
          <UMOSortItem umo={tempUMO} customMetatag={this.props.customMetatag} />
        </BoxItem>
      );
    }
    return (
      <DndProvider backend={HTML5Backend}>
        {umoList}
      </DndProvider>
    );
  }
}

UMOGallerySortView.propTypes = {
  umoList: PropTypes.instanceOf(List),
  customMetatag: PropTypes.string,
  categoryID: PropTypes.string,
  addToSortLightbox: PropTypes.func,
  sortUMO: PropTypes.func,
};

export default injectIntl(connect(null, mapDispatchToProps)(UMOGallerySortView));



// WEBPACK FOOTER //
// ./src/js/components/UMOGallerySortView/index.jsx